package com.milta.feature.route.presentation

sealed interface WebImportRouteIntent {
    /** A file was picked (drag-drop, "Parcourir les fichiers"/"parcourez vos fichiers" or "↺
     * Remplacer") — (re)starts `POST /spreadsheet-imports` from scratch. */
    data class PickFile(val fileBytes: ByteArray, val fileName: String) : WebImportRouteIntent

    /** Écran 1d — "Réessayer", replays the same file (transient 503/network error, no new pick needed). */
    data object RetryServiceCall : WebImportRouteIntent

    /** Écran 2 — a driver's checkbox was toggled (MIL-51 — multi-driver assignment, replaces the
     * former single-selection [SelectDriver]/dropdown). Adds [driverId] to
     * [WebImportRouteState.selectedDriverIds] if absent, removes it otherwise. */
    data class ToggleDriver(val driverId: String) : WebImportRouteIntent

    /** Écran 2 — pencil icon, a row was corrected in place. */
    data class UpdateRow(val rowId: Int, val row: WebImportRouteRow) : WebImportRouteIntent

    /** Écran 2 — "Optimiser l'itinéraire" tapped: creates the batch (`POST /route-batches`, MIL-39
     * contract, MIL-51) for every selected driver — always through the batch endpoint, even when a
     * single driver is selected (one code path, no N=1 special case). On success moves to Écran 3
     * (répartition) rather than dispatching immediately. */
    data object Submit : WebImportRouteIntent

    /** Écran 2d — "Envoyer sans optimisation" tapped: only offered when [Submit] just failed with
     * `optimization_unavailable` (RoutaR down). Reuses the same `POST /route-batches` batch endpoint
     * with `optimize = false` — the existing round-robin split already used for MIL-39 — so a manager
     * isn't stuck waiting on RoutaR to send tournées today. Not a new fallback engine, just exposing
     * an existing backend capability. */
    data object SubmitWithoutOptimization : WebImportRouteIntent

    /** Écran 3 — "Valider et envoyer les tournées" tapped: dispatches the whole batch (`POST
     * /route-batches/{id}/dispatch`, MIL-51). No re-optimization intent from this step — out of scope. */
    data object ValidateAndSend : WebImportRouteIntent

    data object ClearSubmitError : WebImportRouteIntent
}
